import React, { useContext, useState } from "react";
import { usePost } from "../API";
import InterfaceContext, { PublicConfigurationContext } from "../Context";
import { languageContent, safeParse } from "../Util";
import { QuestionProps } from "./Props";
import * as v0 from "@aidkitorg/types/lib/survey";
import { Link } from "react-router-dom";
import { Button } from "@aidkitorg/component-library";

export function ApplicantCreator(props: QuestionProps) {
  const createAssociatedApplicant = usePost('/applicant/create_associated_applicant');
  const [creating, setCreating] = useState(false);
  const context = useContext(InterfaceContext);
  const content = props[languageContent(context.lang)];
  const metadata = safeParse(props.Metadata || '{}') as Partial<v0.ApplicantCreator>;

  async function createNewApplicant() {
    // Using a callback here guarantees that multiple clicks will not cause multiple API calls
    // because React automatically queues the set requests and executes them sequentially.
    setCreating((currentCreating) => {
      if (currentCreating) {
        console.log("Already clicked");
        return currentCreating;
      }
      (async () => {
        const response = await createAssociatedApplicant({ existingApplicantUID: props.uid || '', applicantCreatorTargetField: props['Target Field'] || '' });
        setCreating(false);
        if (response && typeof response === 'object' && response?.success) {
          const newApplicantUID = response.newId;
          if (metadata.openOnCreated?.mode === 'New Tab') {
            window.open(`/a/${newApplicantUID}`, '_blank');
          } else if (metadata.openOnCreated?.mode === 'Same Tab') {
            window.location.href = `/a/${newApplicantUID}`;
          }
        } 
      })();

      return true;
    });
  }

  return <div className="my-2.5">
    {(props.info[props["Target Field"]!] || creating)
      ? <div className='my-1.5'>{creating ? 
        <span>Creating new applicant...</span>
        : <span>Associated applicant created. <Link to={`/a/${props.info[props['Target Field']!]}`} target="_blank">Link {props.info[props['Target Field']!]}</Link></span>
      }</div>
      : (
        <Button
          onClick={createNewApplicant}
          disabled={creating}
        >
          {content}
        </Button>
      )
    }
  </div>;
}
